import { fetchTranslations } from "store/actions/translations";

import { createReducer } from "@reduxjs/toolkit";

export interface ITranslations {
  [key: string]: string;
}

const defaultState: ITranslations = {};

const translations = createReducer(defaultState, builder => {
  builder.addCase(fetchTranslations.fulfilled, (state, action) => {
    return action.payload;
  });
});

export default translations;
